const REFRESH_COOKIE_KEY = 'NH4U_REFRESH_TOKEN';
const REFRESH_FALLBACK_KEY = 'NH4U_REFRESH_TOKEN_FALLBACK';
const REFRESH_TOKEN_MAX_AGE_SECONDS = 7 * 24 * 60 * 60; // 7 days

export function setRefreshToken(refreshToken) {
  if (typeof window === 'undefined' || !refreshToken) {
    return;
  }

  const encodedToken = encodeURIComponent(refreshToken);
  const isHttps = window.location.protocol === 'https:';
  let cookie = `${REFRESH_COOKIE_KEY}=${encodedToken}; Path=/; Max-Age=${REFRESH_TOKEN_MAX_AGE_SECONDS}; SameSite=Strict`;

  // Secure cookies do not work on plain http://localhost.
  if (isHttps) {
    cookie += '; Secure';
  }

  document.cookie = cookie;

  // Fallback in case browser blocks cookies.
  try {
    window.sessionStorage.setItem(REFRESH_FALLBACK_KEY, refreshToken);
  } catch (error) {
    console.warn('Unable to persist refresh token fallback:', error);
  }
}

export function getRefreshToken() {
  if (typeof window === 'undefined') {
    return null;
  }

  // JWTs use '=' padding; never use .split('=')[1] or the token is truncated.
  const prefix = `${REFRESH_COOKIE_KEY}=`;
  const cookiePair = document.cookie
    .split('; ')
    .find((item) => item.startsWith(prefix));

  if (cookiePair) {
    const raw = cookiePair.slice(prefix.length);
    if (raw) {
      return decodeURIComponent(raw);
    }
  }

  try {
    return window.sessionStorage.getItem(REFRESH_FALLBACK_KEY);
  } catch (error) {
    console.warn('Unable to read refresh token fallback:', error);
    return null;
  }
}

export function clearRefreshToken() {
  if (typeof window === 'undefined') {
    return;
  }

  const isHttps = window.location.protocol === 'https:';
  let clearCookie = `${REFRESH_COOKIE_KEY}=; Path=/; Max-Age=0; SameSite=Strict`;

  if (isHttps) {
    clearCookie += '; Secure';
  }

  document.cookie = clearCookie;

  try {
    window.sessionStorage.removeItem(REFRESH_FALLBACK_KEY);
  } catch (error) {
    console.warn('Unable to clear refresh token fallback:', error);
  }
}
